/* DATE revamp — motion + sticky buy bar. Guarded so multiple includes are safe. */
(function(){
  if(window.__drRevamp) return; window.__drRevamp=1;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(){
    var els=[].slice.call(document.querySelectorAll('.dr-reveal'));
    if(!('IntersectionObserver' in window)||reduce){els.forEach(function(e){e.classList.add('dr-in');});return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('dr-in');io.unobserve(x.target);}});},{threshold:0.12,rootMargin:'0px 0px -40px 0px'});
    els.forEach(function(e){io.observe(e);});
  }

  function counts(){
    var els=[].slice.call(document.querySelectorAll('[data-dr-count]'));
    if(!els.length) return;
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.textContent=e.getAttribute('data-dr-count')+(e.getAttribute('data-dr-suffix')||'');});return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){
      if(!x.isIntersecting) return; var el=x.target; io.unobserve(el);
      var t=parseFloat(el.getAttribute('data-dr-count'))||0, sfx=el.getAttribute('data-dr-suffix')||'', dec=(t%1!==0)?1:0;
      if(reduce){el.textContent=t.toFixed(dec)+sfx;return;}
      var s=performance.now(),d=1200;
      (function a(n){var p=Math.min((n-s)/d,1),e=1-Math.pow(1-p,3);el.textContent=(t*e).toFixed(dec)+sfx;if(p<1)requestAnimationFrame(a);else el.textContent=t.toFixed(dec)+sfx;})(s);
    });},{threshold:0.6});
    els.forEach(function(e){io.observe(e);});
  }

  function meters(){
    var els=[].slice.call(document.querySelectorAll('.dr-meter-fill'));
    if(!els.length) return;
    if(!('IntersectionObserver' in window)||reduce){els.forEach(function(e){e.style.width=(e.getAttribute('data-dr-w')||0)+'%';});return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.style.width=(x.target.getAttribute('data-dr-w')||0)+'%';io.unobserve(x.target);}});},{threshold:0.4});
    els.forEach(function(e){io.observe(e);});
  }

  function sticky(){
    var bar=document.getElementById('dr-stickybar'); if(!bar) return;
    var trig=document.querySelector('[data-dr-sticky-trigger]');
    var dismissed=false;
    var close=bar.querySelector('[data-dr-sticky-close]');
    if(close) close.addEventListener('click',function(){dismissed=true;bar.classList.remove('dr-stickybar--show');});
    function upd(){
      var show; if(trig){show=trig.getBoundingClientRect().bottom<10;} else {show=window.scrollY>640;}
      bar.classList.toggle('dr-stickybar--show', show && !dismissed);
    }
    window.addEventListener('scroll',upd,{passive:true}); window.addEventListener('resize',upd); upd();
  }

  function videos(){
    [].slice.call(document.querySelectorAll('video[data-dr-video]')).forEach(function(v){
      v.muted=true; v.setAttribute('muted',''); v.setAttribute('playsinline','');
      var pr=v.play(); if(pr&&pr.catch)pr.catch(function(){});
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(en){en.forEach(function(x){
          if(x.isIntersecting){var p=v.play();if(p&&p.catch)p.catch(function(){});} else {try{v.pause();}catch(e){}}
        });},{threshold:0.1}).observe(v);
      }
    });
  }

  function boot(){reveal();counts();meters();sticky();videos();}
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded',boot);
})();
